import React, { useRef } from 'react';
import { Grid } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { PanelBarGLPure, GridSelectionHLPure, ButtonAddHLPure } from '../../pures';

const DocumentPanelBarExpediente = (props) => {

    let {
        filesExpediente,
        handleWatchExp,
        handleSelectFileExp,
        showBtnAddDocumentToExp,
        addNewFileToExp
    } = props

    const { t } = useTranslation()
    const fileRef = useRef(null);

    const headerColumnOne = (props) => {
        return <span className="documentPanelBarExpediente-header-cell-one">{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className="documentPanelBarExpediente-header-cell-two">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className={`documentPanelBarExpediente-cell-one ${props.dataItem.selected ? "documentPanelBarVersions-cell-selected" : ""}`}  onClick={() =>handleSelectFileExp(props.dataItem)}>
                <span className="gridHLPure-userName">
                    {props.dataItem.name}
                </span>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return(
            <td className={`documentPanelBarExpediente-cell-two ${props.dataItem.selected ? "documentPanelBarVersions-cell-selected" : ""}`}  onClick={() =>handleSelectFileExp(props.dataItem)}>
                <div className={"cellActions-containerBtnsDetails"}>
                    <button
                        className="cellActions-btn"
                        onClick={() => handleWatchExp(props.dataItem)}
                    >
                        <p className="cellActions-textBotton">{t("documentPanelBarExpediente-watch-doc")}</p>
                    </button>
                </div>
            </td>
        )
    }

    let heightGrid = '320px'

    if(filesExpediente.length === 1 || filesExpediente.length === 0){
        heightGrid = '110px'
    }else if(filesExpediente.length === 2){
        heightGrid = '180px'
    }else if(filesExpediente.length === 3){
        heightGrid = '280px'
    }else{
        heightGrid = '320px'
    }

    const addFile = (ref) => {
        ref.current.click()
    };

    return (
        <div className='documentPanelBarExpediente-container'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t("documentPanelBarExpediente-docs-exp")}
                className='documentPanelBarExpediente-panel'
            >
                {
                    showBtnAddDocumentToExp && (
                        <div className='documentPanelBarExpediente-btn-new-doc'>
                            <ButtonAddHLPure
                                nameBtn={t("documentPanelBarExpediente.btn.new.doc")}
                                onClickBtn={() => addFile(fileRef)}
                                iconAdd
                            />
                        </div>
                    )
                }
                <Grid item className="documentPanelBarExpediente-grid-documents">
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={"documentPanelBarExpediente-general-grid"}
                        pageable={false}
                        skip={0}
                        take={filesExpediente.length}
                        dataGrid={filesExpediente}
                        filter={false}
                        columnTwo={true}
                        titleRow1={t("documentPanelBarExpediente-file")}
                        titleRow2={t("documentPanelBarExpediente-action")}
                        headerColumnOne={headerColumnOne}
                        headerColumnTwo={headerColumnTwo}
                        cellColumnOne={cellColumnOne}
                        cellColumnTwo={cellColumnTwo}
                        styleGrid={{ height: heightGrid }}
                    />
                </Grid>        
            </PanelBarGLPure>
            <input
                ref={fileRef}
                onChange={(e) => addNewFileToExp(e)}
                type="file"
                id="fileExp"
                accept="application/pdf"
                style={{ display: "none" }}
            />
        </div>
    )
}

export { DocumentPanelBarExpediente as default }